import store from '@/packages/vuex'
import { Middleware } from '@/app/router'

export default new Middleware('DepartmentSelected', ({ next, router }) => {
	const authUser = store.getters['Auth/user']
	if (authUser.selectedDepartmentId ) {
		return next()
	} else {
		router.push({
			name: 'Dashboard:Home'
		})
	}
})
